import { LOCATION_CHANGE } from 'react-router-redux';

export default {
  LOCATION_CHANGE,
  CUSTOMERS_LIST_REQUESTED: 'app/CUSTOMERS_LIST_REQUESTED',
  CUSTOMERS_LIST_DONE: 'app/CUSTOMERS_LIST_DONE',
  ERROR: 'app/ERROR',
};



// WEBPACK FOOTER //
// ./src/action.types.js